function PerformanceView() {
  return <div style={{ marginTop: 20, fontSize: 26 }}>Performance</div>;
}

export default PerformanceView;
